import { colors } from "@storeblocks/global-styles";
import styled from "styled-components";

interface IconWrapperProps {
  iconPosition: "left" | "right";
}

export const IconWrapper = styled.div<IconWrapperProps>`
  fill: ${colors.green.green50};
  max-height: 15px;
  max-width: 24px;
  padding-left: ${(props) => (props.iconPosition === "right" ? "8px" : "0px")};
  padding-right: ${(props) => (props.iconPosition === "left" ? "8px" : "0px")};
`;
